import { Drawer, Hidden } from '@material-ui/core';
import React, { Component } from 'react';
import { instajobTheme } from '../helpers/instajobTheme';
import MenuItems from './MenuItems';

export default class LeftDrawer extends Component {
    render() {
        const { showDrawer, toggleDrawer } = this.props;
        return (
            <section>
                <Hidden only={['md', 'xl', 'lg']} implementation="js">
                    <Drawer
                        variant="temporary"
                        color="inherit"
                        anchor={instajobTheme.direction === 'rtl' ? 'right' : 'left'}
                        open={showDrawer}
                        onClose={toggleDrawer}
                        ModalProps={{
                            keepMounted: true
                        }}>
                        <MenuItems toggleDrawer={toggleDrawer} />
                    </Drawer>
                </Hidden>
                <Hidden only={['xs', 'sm']} implementation="js">
                    <Drawer
                        color="inherit"
                        variant="permanent"
                        PaperProps={
                            {
                                style: {
                                    backgroundColor: instajobTheme.palette.primary.dark, 
                                    color: 'white',
                                }
                            }
                        }
                        open>
                        <MenuItems toggleDrawer={() => { }} />
                    </Drawer>
                </Hidden>
            </section>
        );
    }
}